import AxiosManager from "../_axiosManager";

export async function getReviewDetail(reviewId: string) {
  const res = await AxiosManager.getInstance().get(
    `/admin/manage/review/${reviewId}`,
  );

  return res;
}

export async function postReview(body: any) {
  const res = await AxiosManager.getInstance().post(
    "/admin/manage/review",
    body,
  );

  return res;
}

export async function putReview({ reviewId, body }: any) {
  const res = await AxiosManager.getInstance().put(
    `/admin/manage/review/${reviewId}`,
    body,
  );

  return res;
}

export async function delReview(reviewId: string) {
  const res = await AxiosManager.getInstance().delete(
    `/admin/manage/review/${reviewId}`,
  );

  return res;
}
